import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getMetricCardsData = ({
  isLive,
  dateRange,
  status
}: {
  isLive: boolean,
  dateRange: {
    start_date: string,
    end_date: string
  },
  status: 'success' | 'pending' | 'failed' | 'all'
}) => {

  const params = {
    is_live: isLive,
    start_date: dateRange.start_date,
    end_date: dateRange.end_date,
    status: status
  };

  return axiosPrivate.get(`/dashboard/v1/transaction/metrics/cards`, { params: params });
};